// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"styles_form-wrapper__VWtGM","form":"styles_form__xJNyX","inputs":"styles_inputs__2eNTg","buttons":"styles_buttons__KRqk4"};